<template>
  <div class="rew19_aro_wrap shop">
    <div class="rew19_listback">
      <div class="rew19_basketList_wrap">
        <div class="rew19_goods-detail rew19_clear">
          <div class="rew19_goods-photo heartLine">
            <div class="swiper-container rew19_goods-slider">
              <span class="rew18_goodsDim" v-if="product.isSoldOut == 'Y'">
                <em>일시품절</em>
              </span>
              <img
                class="retina_img"
                :src="product.pd_img_url2"
                alt="제품이미지"
                onError="imageError(this)" data-error-cnt="0"
              />
            </div><!--//swiper-container-->
          </div><!--//rew19_goods-photo-->
          <!-- goodsInfo -->
          <div class="rew19_goods-info">
            <div class="keepopen" closable="true">
              <ul ref="dropdown-menu" id="dropdown-menu" class="rew19_snsWrap dropdown-menu repo-selec">
                <li><a @click="urlClip()" class="rew19_sns04" id="urlLinkBtn"><img src="https://resource2018.nuskinkorea.co.kr//images/renew/sns06.png"></a></li>
                <li><a @click="onClickShareSns('5')" class="rew19_sns01" id="kakaoLinkBtn"><img src="https://resource2018.nuskinkorea.co.kr//images/renew/sns01.png"></a></li>
                <li class="facebook-link-btn"><a @click="onClickShareSns('1')" class="rew19_sns02" id="facebookLinkBtn"><img src="https://resource2018.nuskinkorea.co.kr//images/renew/sns02.png"></a></li>
<!--                <li><a @click="onClickShareSns('2')" class="rew19_sns03" id="kakaoStoryLinkBtn"><img src="https://resource2018.nuskinkorea.co.kr//images/renew/sns03.png"></a></li>-->
              </ul>
              <a class="rew19_snsShare" @click="onClickSnsDropdown"></a>
            </div>

            <!-- 상품 타이틀 -->
            <div class="rew19_goods-title">
              <span class="rew19_goods_num">[제품번호 :{{product.pd_id}}]</span>
              <h2 class="rew19_detailTit">
                <span class="prodNm">{{product.pd_name_kr}}</span>
                <br />
                <span class="txt_eng">{{product.pd_name_en}}</span>
              </h2>
            </div>

            <!-- 상품 타이틀 //-->
            <div class="rew19_payment-option">
              <div class="rew19_number-price">
                <strong class="aro">회원가</strong>
                <span class="rew19_cancelline" style="text-decoration: inherit;">
                  <span class="price">{{$fmt.WON(product.membersPrice)}}</span>
                  <label>원</label>
                </span>
              </div>
              <div class="rew19_number-price">
                <strong>정기구매가</strong>
                <span class="price">{{$fmt.WON(product.d_pd_amt)}}</span>
                <label>원</label>
              </div>
              <div class="rew19_numbering_wrap">
                <em class="rew19_gTit">수량</em>
                <div class="rew19_numbering">
                  <a @click="setCount(-1)" class="rew19_numbering_down product_qty_down" title="감소"></a>
                  <input
                    type="tel"
                    class="onlynum product_qty"
                    title="수량"
                    @keypress="numberKeyPress($event)"
                    @keyup="calcTempCart();"
                    v-model.trim="tempCart.pd_count"
                    style="ime-mode:disabled"
                  />
                  <a @click="setCount(+1)" class="rew19_numbering_up product_qty_up" title="증가"></a>
                </div>
              </div>
            </div>
            <!--//rew19_payment-option-->

            <!-- 정기구매가 안내 -->
            <div v-if="pd_type == 'uspan'" class="rew19_pay-info rew19_trenches">
              <div class="rew19_bgtxtbox">
                <p>
                  정기구매 시
                  <span class="rew19_point">첫달부터 15%</span>
                  할인
                </p>
              </div>
            </div>
            <div v-else-if="pd_type != 'ntc'" class="rew19_pay-info rew19_trenches">
              <div class="rew19_bgtxtbox">
                <p>
                  정기구매 시
                  <span class="rew19_point">첫달부터 5%</span>
                  할인,
                  <span class="rew19_point">4개월부터 10%</span>
                  할인
                </p>
              </div>
            </div>

            <!-- 정기구매가 안내 //-->

            <!-- 상품합계 -->
            <div class="rew19_sumArea">
              <em class="rew19_sumTit">상품 합계</em>
              <span class="rew19_unit">
                <strong class="rew19_sumNum dev-total-price">{{$fmt.WON(tempCart.total_amt)}}</strong>원
              </span>
            </div>
            <!-- 상품합계 //-->

            <div class="rew19_payment_golist">
              <a class="rew19_cart" @click="onClickAddCart(product)">정기구매 담기</a>
            </div>
          </div>
          <!-- goodsInfo //-->
        </div>
        <!--//rew19_goods-detail-->

        <div class="tab-content rew19_tabCont">
          <div class="tab-pane fade active in" id="tab1">
            <h2 class="rew19_tab_title">상세설명</h2>

            <template v-if="getMemberType() == 'DIST' || getMemberType() == 'PREF' || getMemberType() == 'GENERAL'">

              <div v-if="pd_type == 'uspan'" class="rew19_option-list">
                <div class="rew19_option-box">
                  <ul>
                    <li v-if="getMemberType() == 'PREF' || getMemberType() == 'GENERAL'" class="flex-grow0">
                      <strong>SV</strong>
                      <span class="number">
                          <em class="rew19_per">15%</em>
                          <em class="rew19_value">{{$fmt.PV(product.pv3)}}</em>
                      </span>
                    </li>
                    <template v-if="getMemberType() == 'DIST'">
                      <li>
                        <strong>SV</strong>
                        <span class="number">
                          <em class="rew19_per">15%</em>
                          <em class="rew19_value">{{$fmt.PV(product.pv3)}}</em>
                        </span>
                      </li>
                      <li>
                        <strong>CSV</strong>
                        <span class="number">
                          <em class="rew19_per">15%</em>
                          <em class="rew19_value">{{$fmt.PV(product.cv3)}}</em>
                        </span>
                      </li>
<!--                      <li>-->
<!--                        <strong>SB</strong>-->
<!--                        <span class="number">-->
<!--                          <em class="rew19_per">15%</em>-->
<!--                          <em class="rew19_value">{{$fmt.SV(product.sb3)}}</em>-->
<!--                        </span>-->
<!--                      </li>-->
                    </template>
                  </ul>
                </div>
              </div>

              <div v-else-if="pd_type == 'ntc'" class="rew19_option-list">
                <div class="rew19_option-box">
                  <ul>
                    <li v-if="getMemberType() == 'PREF' || getMemberType() == 'GENERAL'" class="flex-grow0">
                      <strong>SV</strong>
                      <span class="number">
                        <em class="rew19_per"></em>
                        <em class="rew19_value">{{$fmt.PV(product.pv)}}</em>
                      </span>
                    </li>
                    <template v-if="getMemberType() == 'DIST'">
                      <li>
                        <strong>SV</strong>
                        <span class="number">
                        <em class="rew19_per"></em>
                        <em class="rew19_value">{{$fmt.PV(product.pv)}}</em>
                      </span>
                      </li>
                      <li>
                        <strong>CSV</strong>
                        <span class="number">
                          <em class="rew19_per"></em>
                          <em class="rew19_value">{{$fmt.PV(product.cv)}}</em>
                        </span>
                      </li>
<!--                      <li>-->
<!--                        <strong>SB</strong>-->
<!--                        <span class="number">-->
<!--                          <em class="rew19_per"></em>-->
<!--                          <em class="rew19_value">{{$fmt.SV(product.sb)}}</em>-->
<!--                        </span>-->
<!--                      </li>-->
                    </template>
                  </ul>
                </div>
              </div>

              <div v-else class="rew19_option-list">
                <div class="rew19_option-box">
                  <ul>
                    <li v-if="getMemberType() == 'PREF' || getMemberType() == 'GENERAL'" class="flex-grow0">
                      <strong>SV</strong>
                      <span class="number">
                        <em class="rew19_per">5%</em>
                        <em class="rew19_value">{{$fmt.PV(product.pv1)}}</em>
                      </span>
                      <span class="number">
                        <em class="rew19_per">10%</em>
                        <em class="rew19_value">{{$fmt.PV(product.pv2)}}</em>
                      </span>
                    </li>
                    <template v-if="getMemberType() == 'DIST'">
                      <li>
                        <strong>SV</strong>
                        <span class="number">
                        <em class="rew19_per">5%</em>
                        <em class="rew19_value">{{$fmt.PV(product.pv1)}}</em>
                      </span>
                        <span class="number">
                        <em class="rew19_per">10%</em>
                        <em class="rew19_value">{{$fmt.PV(product.pv2)}}</em>
                      </span>
                      </li>
                      <li>
                        <strong>CSV</strong>
                        <span class="number">
                          <em class="rew19_per">5%</em>
                          <em class="rew19_value">{{$fmt.PV(product.cv1)}}</em>
                        </span>
                        <span class="number">
                          <em class="rew19_per">10%</em>
                          <em class="rew19_value">{{$fmt.PV(product.cv2)}}</em>
                        </span>
                      </li>
<!--                      <li>-->
<!--                        <strong>SB</strong>-->
<!--                        <span class="number">-->
<!--                          <em class="rew19_per">5%</em>-->
<!--                          <em class="rew19_value">{{$fmt.SV(product.sb1)}}</em>-->
<!--                        </span>-->
<!--                        <span class="number">-->
<!--                          <em class="rew19_per">10%</em>-->
<!--                          <em class="rew19_value">{{$fmt.SV(product.sb2)}}</em>-->
<!--                        </span>-->
<!--                      </li>-->
                    </template>
                  </ul>
                </div>
              </div>

            </template>

            <div class="rew19_option-content" v-html="product.pd_detail"></div>

          </div>
        </div>
      </div>
      <!--//rew19_basketList_wrap-->
    </div>
    <!--//rew19_listback-->

    <div class="rew19_basket_wrap detail on rew19_mobileView">
      <div class="rew19_basket_center">
        <div class="rew19_basket_rate">
          <ul class="rew19_basket_detail">
            <li class="rew19_basket_su">
              <em>수량</em>
              <div class="rew19_numbering">
                <a @click="setCount(-1)" class="rew19_numbering_down product_qty_down" title="감소" ></a>
                <input
                  type="tel"
                  class="onlynum product_qty" title="수량"
                  v-model.trim="tempCart.pd_count"
                  @keypress="numberKeyPress($event)"
                  @keyup="calcTempCart();"
                  style="ime-mode:disabled"
                  />
                <a @click="setCount(+1)" class="rew19_numbering_up product_qty_up" title="증가" ></a>
              </div>
            </li>
            <li v-if="getMemberType() == 'DIST' || getMemberType() == 'PREF' || getMemberType() == 'GENERAL'" class="rew19_basket_pv">
              <em>SV</em>
              <span class="rew19_money dev-total-sv">{{$fmt.SV(tempCart.total_pv)}}</span>
            </li>
            <li class="rew19_basket_sum">
              <i class="dev-total-price">{{$fmt.WON(tempCart.total_amt)}}</i>
              <span class="rew19_unit">원</span>
            </li>
          </ul>
        </div>
        <a class="rew19_basket_oder dev-addCart" @click="onClickAddCart(product)">정기구매 담기</a>
      </div>
      <!--//rew19_basket_center-->
    </div>
    <cart-added-popup :show="showCartAdded" :message="showCartAddedMessage"></cart-added-popup>
    <cart-add-dialog
      ref="cartAddDialog"
      :show="cartAddDialogShow"
      :data='cartAddDialog'
      @close='onCloseCartAddDialog'></cart-add-dialog>

    <ntc-cart-add-dialog
      ref="ntcCartAddDialog"
      :show="ntcCartAddDialogShow"
      @close='onCloseNtcCartAddDialog'></ntc-cart-add-dialog>
  </div>
  <!--rew19_aro_wrap-->
</template>
<script>
import AroBase from '@/components/base/AroBase';
import CartAddedPopup from '@/components/popup/CartAdded';
import CartAddDialog from '@/components/popup/CartAddDialog';
import NtcCartAddDialog from '@/components/popup/NtcCartAddDialog';
import * as Const from "@/utils/const";
import * as ErrMsg from "@/utils/error_msg";

const MAX_PD_COUNT = 999;
const ERR_TITLE = "안내";
const ERR_MSG_MIN_PD_COUNT = "최소 구매 수량보다 작습니다.";
const ERR_MSG_MAX_PD_COUNT = "최대 구매 수량을 초과 하였습니다.";
const ERR_MSG_MAX_PD_COUNT_1 = "해당 제품은 1개만 구매 가능합니다.";

export default {
  name: "productDetail",
  extends: AroBase,
  components: { CartAddedPopup, CartAddDialog, NtcCartAddDialog },
  props: {
    pd_type: {
      type: String,
      default: ""
    },
    ref_title : {
      type: String,
      default: ""
    }
  },
  computed: {
    isNuskinChannel : function() {
      return this.$aroChannel == Const.ARO_CHANNEL_NUSKIN;
    }
  },
  data: () => ({
    product: {
        // pd_id: '18101366',
        // pd_name_kr: '얼티밋 마스크 A.C 케어(KO)',
        // pd_name_en: 'Ultimate Mask A.C Care (KO)',
        // membersPrice: '3000',
        // pd_amt1: '3000',
        // pd_img_url2: 'https://resource2018.nuskinkorea.co.kr/images/prod/18101366.jpg',
        // pv1: '43.33',
        // pv2: '41.05',
        // cv1: '44.736.36',
        // cv2: '42.381.82',
        // sb1: '5,130.00',
        // sb2: '4,860.00',
        // pd_detail: '문제성 피부를 3단계로 잠재워 주는 S.O.S 마스크 피부고민 응급 솔루션',
        // pd_count: 1,
        // pd_total_amt: '3000'
    },

    showCartAdded : false,
    showCartAddedMessage : "신규 장바구니 담기 성공!",
    tempCart : {
      pd_id : null,
      pd_count : 1,
      pd_pv : 0
    },

    params : {
      pd_id: "N",
      big_classcodes: "",
      search_typ: "",
      search_key: ""
    },

    cartAddDialogShow : false,
    cartAddDialog : {
      rawData : {
        countPerPage: 5,
        page: 1,
        totalCount: 0,
        //...
      },
      resData : {
        addTo : "CART", //장바구니:CART, aro_no:기존Aro에 추가
        aroData : null,
      }
    },

    ntcCartAddDialogShow : false,
    ntcCartAddDialog : {
      rawData : {
        //...
      },
      resData : {
        addTo : "", //aro_no:기존Aro에 추가
        aroData : null,
      }
    },

    testText : ""
  }),
  created() {
    // let _this = this;
  },
  mounted() {

    const metaTag = document.createElement('meta');
    metaTag.name = 'viewport';
    metaTag.content = 'width=device-width, initial-scale=1.0, user-scalable=yes, maximum-scale=3.0';
    document.head.appendChild(metaTag);

    var _this = this;
    _this.params.pd_id = _this.$route.params.pd_id;

    _this.loadItem();
    _this.$aroSnsInit();
  },
  methods: {
    /**
     * API Request
     */

    //상품 상세 가져오기
    apiGetProductDetail : function(){
      let _this = this;
      return _this.$http.get(`${_this.$aroApiBasePath}/aro/product/detail`, {
        params: {
          pd_id :_this.params.pd_id
        }
      });
    },

    //장바구니 정보 가져오기
    apiGetCart : function(){
      let _this = this;

      return _this.$http.get(`${_this.$aroApiBasePath}/aro/get_cart`, {
        params: {}
      });
    },

    //장바구니에 상품 추가
    apiAddProductInCart : function(pd_id, pd_count, division_code){
      let _this = this;

      let pdAddList = [
        {
          pd_id : pd_id,
          pd_count : pd_count,
          division_code : division_code
        }
      ];

      return _this.$http.get(`${_this.$aroApiBasePath}/aro/put_cart`, {
        params: {
          pd_add_list : JSON.stringify(pdAddList)
        },
        paramsSerializer: function (params) {
          return require('qs').stringify(params, {arrayFormat: 'brackets'})
        },
      });
    },

    //장바구니에 상품 추가(uspan)
    apiAddProductInUspanCart : function(pd_id, pd_count){
      let _this = this;

      //18155987 해당 제품 구매 수량 제한
      if(pd_id=='18155987' && pd_count>1){
        _this.$dialogs.alert(ERR_MSG_MAX_PD_COUNT_1, {title: ERR_TITLE})
          .then(res => {});
          pd_count = 1;
      }

      return _this.$http.get(`${_this.$aroApiBasePath}/aro/put_cart_uspan`, {
        params: {
          product_code : pd_id,
          product_count : pd_count
        }
      });
    },

    //나의 ARO 정보 가져오기
    apiGetAro : function(pageNo){
      let _this = this;

      return _this.$http.get(`${_this.$aroApiBasePath}/aro/get_aro`, {
        params: {
          isUspan : "N",
          page : pageNo,
          countPerPage : _this.cartAddDialog.rawData.countPerPage
        }
      });
    },

    //ARO 변경 가능 여부 체크
    apiCheckAroModifyStatus : function(aro_no){
      let _this = this;

      return _this.$http.get(`${_this.$aroApiBasePath}/aro/modify_status`, {
        params: {
          adpNo : aro_no
        }
      });
    },

    //나의 ARO에 상품 추가
    apiAddProductInAro : function(aro_no, pd_id, pd_count){
      let _this = this;

      let pdAddList = [
        {
          pd_id : pd_id,
          pd_count : pd_count
        }
      ];

      return _this.$http.get(`${_this.$aroApiBasePath}/aro/add_products`, {
        params: {
          aro_no : aro_no,
          pd_add_list : JSON.stringify(pdAddList)
        },
        paramsSerializer: function (params) {
          return require('qs').stringify(params, {arrayFormat: 'brackets'})
        },
      });
    },

    //나의 Ntc 정보 가져오기
    apiGetNtc : function(){
      let _this = this;

      return _this.$http.get(`${_this.$aroApiBasePath}/aro/get_ntc`, {
        params: {}
      });
    },

    //Ntc 장바구니에 상품 추가
    apiAddProductInNtcCart : function(pd_id, pd_count){
      let _this = this;

      let pdAddList = [
        {
          pd_id : pd_id,
          pd_count : pd_count
        }
      ];

      return _this.$http.get(`${_this.$aroApiBasePath}/aro/ntc/add_carts`, {
        params: {
          pd_add_list : JSON.stringify(pdAddList)
        },
        paramsSerializer: function (params) {
          return require('qs').stringify(params, {arrayFormat: 'brackets'})
        },
      });
    },

    //나의 NTC ARO에 상품 추가
    apiAddProductInNtcAro : function(pd_id, pd_count){
      let _this = this;

      let pdAddList = [
        {
          pd_id : pd_id,
          pd_count : pd_count
        }
      ];

      return _this.$http.get(`${_this.$aroApiBasePath}/aro/ntc/post_products`, {
        params: {
          pd_list : JSON.stringify(pdAddList)
        },
        paramsSerializer: function (params) {
          return require('qs').stringify(params, {arrayFormat: 'brackets'})
        },
      });
    },

    /**
     * Local function
     */
    loadItem : function(){
       var _this = this;

      //show loading
      _this.$showLoading();
      _this.apiGetProductDetail().then(res=>{

        //Check NTC
        let isNtc = _this.AroConst.ARO_NTC_PRODUCT_IDS.includes(_this.params.pd_id);

        _this.product = {
          ...res.data,
          isNtc : isNtc,
          d_pd_amt : 0,
          d_pv : 0.00,
        };

        let pd_type = _this.pd_type;
        if(_this.product.uspan_yn == "Y"){
          pd_type = "uspan";
        }

        switch(pd_type){
        case "uspan":
          _this.product.d_pd_amt = parseInt(""+_this.product.pd_amt3, 10);
          _this.product.d_pv = parseFloat(""+_this.product.pv3);
          break;
        case "ntc":
          _this.product.d_pd_amt = parseInt(""+_this.product.membersPrice, 10);
          _this.product.d_pv = parseFloat(""+_this.product.pv);
          break;
        default:
          _this.product.d_pd_amt = parseInt(""+_this.product.pd_amt1, 10);
          _this.product.d_pv = parseFloat(""+_this.product.pv1);
          break;
        }

        _this.product.pd_total_amt = _this.product.d_pd_amt;
        _this.tempCart = {
          pd_id : _this.product.pd_id,
          division_code : _this.product.division_code,
          pd_count : 1,
          total_pv : _this.product.d_pv * 1,
          total_amt : _this.product.d_pd_amt * 1
        };

      }).catch((err)=>{
        console.error(err);
        _this.$dialogs.alert(ErrMsg.COMM_UNKNOWN_MESSAGE, {title: ErrMsg.COMM_ERROR_TITLE})
        .then(res => {});

      }).finally(()=>{
        //hide loading
        _this.$hideLoading();

        //GA 전송-상품 상세
        try{
          _this.sendGaProductDetail();
        }catch(e){
          //ignore
          console.error(e);
        }

        //we jin 이미지 맵 리사이징 실행
        try {
          //$("img[usemap]").rwdImageMaps();

          if ("function" === typeof callbackRwdImageMaps) {
            callbackRwdImageMaps();
          }

        } catch (e1) {
          console.error(e1);
        }

      });
    },

    setCount: function(add) {
      let _this = this;

      /*if(_this.product.uspan_yn == 'Y'){
        _this.$dialogs.alert('15% 정기구매 상품은 1개만 구매 가능합니다.')
        .then(res => {});
        return;
      }*/

      _this.tempCart.pd_count = parseInt(_this.tempCart.pd_count, 10) + add;
      _this.tempCart.pd_count = Math.max(_this.tempCart.pd_count, 1); //최소 1
      _this.tempCart.pd_count = Math.min(_this.tempCart.pd_count, 999); //최대 999
      _this.calcTempCart();

    },

    calcTempCart : function(){
      let _this = this;

      _this.tempCart.pd_count = (""+_this.tempCart.pd_count).replace(/[^0-9]/g, "");
      _this.tempCart.pd_count = parseInt(""+_this.tempCart.pd_count, 10);
      if(!_this.tempCart.pd_count || _this.tempCart.pd_count == NaN){
        _this.tempCart.pd_count = 1;
      }

      if(_this.tempCart.pd_count < 1){
        _this.tempCart.pd_count = 1;
      }

      /*if(_this.product.uspan_yn == 'Y'){
        _this.tempCart.pd_count = 1;
        _this.$dialogs.alert('15% 정기구매 상품은 1개만 구매 가능합니다.')
        .then(res => {});
        return;
      }*/

      if(MAX_PD_COUNT < _this.tempCart.pd_count){
        _this.$dialogs.alert(ERR_MSG_MAX_PD_COUNT, {title: ERR_TITLE})
        .then(res => {});
        _this.tempCart.pd_count = MAX_PD_COUNT;
      }

      _this.tempCart.total_amt = _this.product.d_pd_amt * _this.tempCart.pd_count;
      _this.tempCart.total_pv = _this.product.d_pv * _this.tempCart.pd_count;
    },

    numberKeyPress(evt) {
      evt = (evt) ? evt : window.event;
      var charCode = (evt.which) ? evt.which : evt.keyCode;
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
        evt.preventDefault();;
      } else {
        return true;
      }
    },

    keyUpToNumber(evt, callback){
      evt = (evt) ? evt : window.event;
      evt.target.value = evt.target.value.replace(/[^0-9]/g, "");
    },

    //Sns 공유
    onClickShareSns(type){
      let _this = this;
      let linkUrl = document.location.href;
      let addParams = 'utm_source=kakaotalk&utm_medium=product_detail';

      linkUrl+=(linkUrl.indexOf("?") > 0 ? "&" : "?") + addParams;
      _this.$aroSnsShareAction(
        _this.product.pd_name_kr, //snsTitle
        linkUrl, //shareLinkUrl
        _this.product.pd_img_url2, //shareImgUrl
        type //snsType
      );
    },

    onClickSnsDropdown(){
      let _this = this;

      if(_this.$refs['dropdown-menu'].classList.contains('sns_show')){
        _this.$refs['dropdown-menu'].classList.remove('sns_show');
      }else{
        _this.$refs['dropdown-menu'].classList.add('sns_show');
      }
    },

    //장바구니 추가
    onClickAddCart : function(product){
      let _this = this;

      if(!_this.isLogined()){
        //비 로그인시
        _this.$openLoginConfirm();
        return;
      }

      if(product.isSoldOut == 'Y'){
         _this.$dialogs.alert('품절된 상품입니다.').then(res => {});
        return;
      }

      let pd_type = _this.pd_type;
      if(_this.product.uspan_yn == "Y"){
        pd_type = "uspan";
      }

      switch(pd_type){
      case "uspan":
        _this.addCart15PerProduct();
        break;
      case "ntc":
        _this.addCartNtcProduct();
        break;
      default:
        _this.addCartNormalProduct();
        break;
      }

      //GA 전송-장바구니 클릭
      try{
        _this.sendGaProductToCart(_this.product, _this.tempCart.pd_count);
      }catch(e){
        //ignore
        console.error(e);
      }
    },

    //일반상품 장바구니 담기
    addCartNormalProduct(){
      let _this = this;

      let pd_id = _this.product.pd_id;
      let pd_count = _this.tempCart.pd_count;
      let division_code = _this.product.division_code;

      let reqPageNo = 1;
      _this.$showLoading();
      _this.apiGetAro(reqPageNo).then(res=>{
        if (res.status === 200 && res.data.status === "0000") {
          _this.cartAddDialog.rawData = res.data;

          if(!_this.cartAddDialog.rawData.totalCount || _this.cartAddDialog.rawData.totalCount <= 0){
            // ARO내역이 없으면, 바로 장바구니에 추가
            return _this.apiAddProductInCart(pd_id, pd_count, division_code);
          }

          //정기구매 선택 Dialog 표시
          _this.cartAddDialog.targetProduct = {
            pd_id : pd_id, division_code : division_code, pd_count : pd_count,
            pd_type : "", //일반상품
          };
          _this.$refs.cartAddDialog.initData();
          _this.cartAddDialogShow = true;
        }else{
          //console.error(res);
          let errMsg = res.data.message ? res.data.message : ErrMsg.COMM_UNKNOWN_MESSAGE;
          _this.$dialogs.alert(errMsg)
          .then(res => {});
        }

        return null;
      }).then(res=>{
        if(res){
          if (res.status === 200 && res.data.status === "0000") {
            _this.showCartAddedMessage = "신규 장바구니 담기 성공!";
            _this.showCartAdded = true;
            setTimeout(()=>{
              _this.showCartAdded = false;
            }, 1000);

            //장바구니 변경 handler
            _this.$changeBasketCount();

          }else{
            //console.error(res);
            let errMsg = res.data.message ? res.data.message : ErrMsg.COMM_UNKNOWN_MESSAGE;
            _this.$dialogs.alert(errMsg)
            .then(res => {});
          }
        }
      }).catch((err)=>{
        console.error(err);

        _this.$dialogs.alert(ErrMsg.COMM_UNKNOWN_MESSAGE, {title: ErrMsg.COMM_ERROR_TITLE})
        .then(res => {});

      }).finally(()=>{
        _this.$hideLoading();
      });
    },

    //장바구니 다이얼로그 처리
    onCloseCartAddDialog(isOk, data) {
      let _this = this;
      _this.cartAddDialogShow = false;

      if(!isOk){
        //Do nothing.
        return;
      }

      //장바구니 직접등록 or 기존 aro 에 추가
      let retData = data;

      let pd_id = _this.cartAddDialog.targetProduct.pd_id;
      let division_code = _this.cartAddDialog.targetProduct.division_code;
      let pd_count = _this.cartAddDialog.targetProduct.pd_count;
      let targetAro = retData.resData.aroData;

      if(retData.resData.addTo === "CART"){
        //장바구니에 추가
        _this.$showLoading();
        _this.apiAddProductInCart(pd_id, pd_count, division_code).then((res)=>{
          if (res.status === 200 && res.data.status === "0000"){
            //장바구니에 추가 popup
            _this.showCartAddedMessage = "신규 장바구니 담기 성공!";
            _this.showCartAdded = true;
            setTimeout(()=>{
              _this.showCartAdded = false;
            }, 1000);

            //장바구니 변경 handler
            _this.$changeBasketCount();

          }else{
            //console.error(res);
            let errMsg = res.data.message ? res.data.message : ErrMsg.COMM_UNKNOWN_MESSAGE;
            _this.$dialogs.alert(errMsg)
            .then(res => {});
          }
        }).catch((err)=>{
          console.error(err);

          _this.$dialogs.alert(ErrMsg.COMM_UNKNOWN_MESSAGE, {title: ErrMsg.COMM_ERROR_TITLE})
          .then(res => {});

        }).finally(()=>{
          _this.$hideLoading();
        });

      }else{

        //기존 ARO에 추가
        _this.$showLoading();
        _this.apiCheckAroModifyStatus(retData.resData.addTo).then((res)=>{
          if (res.status === 200 && res.data.status === "0000") {
            return _this.apiAddProductInAro(retData.resData.addTo, pd_id, pd_count);
          }else{
            //ARO 변경 불가능한 경우
            //console.error(res);
            let errMsg = res.data.message ? res.data.message : ErrMsg.COMM_UNKNOWN_MESSAGE;
            _this.$dialogs.alert(errMsg)
            .then(res => {});
            return null;
          }

        }).then((res)=>{
          if(res){
            if (res.status === 200 && res.data.status === "0000") {
              //기존 ARO에 추가 결과 msg
              let msg = '';
              msg += `정기구매 ${targetAro.aro_no}(${targetAro.subject})에 상품을 추가 하였습니다.<br/>`;
              msg += '동일한 상품이 있는 경우 자동으로 수량이 추가됩니다.<br/>';
              msg += '추가한 상품은 해당 정기결제일에 합산하여 배송됩니다.';

              _this.$dialogs.alert(msg).then(res => {});

            }else{
              //console.error(res);
              let errMsg = res.data.message ? res.data.message : ErrMsg.COMM_UNKNOWN_MESSAGE;
              _this.$dialogs.alert(errMsg)
              .then(res => {});
            }
          }
        }).catch((err)=>{
          console.error(err);

          _this.$dialogs.alert(ErrMsg.COMM_UNKNOWN_MESSAGE, {title: ErrMsg.COMM_ERROR_TITLE})
          .then(res => {});

        }).finally(()=>{
          _this.$hideLoading();
        });
      }
    },

    //15% 상품 장바구니 담기
    addCart15PerProduct(){
      let _this = this;

      if(!_this.isLogined()){
        //비 로그인시
        _this.$openLoginConfirm();
        return;
      }

      _this.$showLoading();
      _this.apiAddProductInUspanCart(_this.product.pd_id, _this.tempCart.pd_count).then(res=>{
        if(res){
          if (res.status === 200 && res.data.status === "0000") {
            _this.showCartAddedMessage = "신규 정기구매 담기 성공!<br/>장바구니 유의사항을 확인하세요.";
            _this.showCartAdded = true;
            setTimeout(()=>{
              _this.showCartAdded = false;
            }, 2000);

            //장바구니 변경 handler
            _this.$changeBasketCount();
          }else{
            //console.error(res);
            let errMsg = res.data.message ? res.data.message : ErrMsg.COMM_UNKNOWN_MESSAGE;
            _this.$dialogs.alert(errMsg)
              .then(res => {});
          }
        }
      }).catch(()=>{
        _this.$dialogs.alert(ErrMsg.COMM_UNKNOWN_MESSAGE, {title: ErrMsg.COMM_ERROR_TITLE})
        .then(res => {});

      }).finally(()=>{
        _this.$hideLoading();
      });
    },

    //NTC 상품 장바구니 담기
    addCartNtcProduct(){
      let _this = this;

      let pd_id = _this.product.pd_id;
      let pd_count = _this.tempCart.pd_count;

      _this.$showLoading();
      _this.apiGetNtc().then(res=>{

        if (res.status === 200 && res.data.status === "0000") {
          _this.ntcCartAddDialog.rawData = res.data;

          if(!_this.ntcCartAddDialog.rawData.ntcNo &&
            _this.ntcCartAddDialog.rawData.ntc_status != "1"){
            // ARO내역이 없으면, 바로 ntc 장바구니에 추가
            return _this.apiAddProductInNtcCart(pd_id, pd_count);
          }

          //정기구매 선택 Dialog 표시
          _this.ntcCartAddDialog.targetProduct = {
            pd_id : pd_id, pd_count : pd_count,
            pd_type : "ntc", //Ntc 상품
          };
          _this.$refs.ntcCartAddDialog.initData(_this.ntcCartAddDialog);
          _this.ntcCartAddDialogShow = true;
        }else{
          //console.error(res);
          let errMsg = res.data.message ? res.data.message : ErrMsg.COMM_UNKNOWN_MESSAGE;
          _this.$dialogs.alert(errMsg)
          .then(res => {});
        }

        return null;
      }).then(res=>{
        if(res){
          if (res.status === 200 && res.data.status === "0000") {
            //장바구니 추가 완료 표시
            _this.showCartAddedMessage = "신규 장바구니 담기 성공!";
            _this.showCartAdded = true;
            setTimeout(()=>{
              _this.showCartAdded = false;
            }, 1000);

            //장바구니 변경 handler
            _this.$changeBasketCount();

          }else{
            //console.error(res);
            let errMsg = res.data.message ? res.data.message : ErrMsg.COMM_UNKNOWN_MESSAGE;
            _this.$dialogs.alert(errMsg)
            .then(res => {});
          }
        }
      }).catch((err)=>{
        console.error(err);

        _this.$dialogs.alert(ErrMsg.COMM_UNKNOWN_MESSAGE, {title: ErrMsg.COMM_ERROR_TITLE})
        .then(res => {});

      }).finally(()=>{
        _this.$hideLoading();
      });
    },

    //NTC 장바구니 다이얼로그 처리
    onCloseNtcCartAddDialog(isOk, data) {
      let _this = this;
      _this.ntcCartAddDialogShow = false;

      if(!isOk){
        //Do nothing.
        return;
      }

      //기존 aro 에 추가
      let retData = data;

      let pd_id = _this.ntcCartAddDialog.targetProduct.pd_id;
      let pd_count = _this.ntcCartAddDialog.targetProduct.pd_count;
      let pd_type = _this.ntcCartAddDialog.targetProduct.pd_type;
      let targetAro = retData.resData.aroData;

      //기존 ARO에 추가
      _this.$showLoading();
      _this.apiAddProductInNtcAro(pd_id, pd_count).then((res)=>{
        if (res.status === 200 && res.data.status === "0000") {
          //기존 ARO에 추가 결과 msg
          let msg = '';
          msg += `정기기부 ${targetAro.ntcNo}에 상품을 추가 하였습니다.<br/>`;
          msg += '동일한 상품이 있는 경우 자동으로 수량이 추가됩니다.<br/>';
          msg += '추가한 상품은 해당 정기 결제일에 합산하여 결제됩니다.';

          _this.$dialogs.alert(msg).then(res => {});

        }else{
          //console.error(res);
          let errMsg = res.data.message ? res.data.message : ErrMsg.COMM_UNKNOWN_MESSAGE;
          _this.$dialogs.alert(errMsg)
          .then(res => {});
        }
      }).catch((err)=>{
        console.error(err);

        _this.$dialogs.alert(ErrMsg.COMM_UNKNOWN_MESSAGE, {title: ErrMsg.COMM_ERROR_TITLE})
        .then(res => {});

      }).finally(()=>{
        _this.$hideLoading();
      });
    },

    //GA 전송-상품 상세
    sendGaProductDetail(){
      let _this = this;

      let price = parseInt(""+_this.product.pd_amt1, 10);
      let pd_type = _this.pd_type;
      if(_this.product.uspan_yn == "Y"){
        pd_type = "uspan";
      }

      switch(pd_type){
      case "uspan":
        price = parseInt(""+_this.product.pd_amt3, 10);
        break;
      case "ntc":
        price = parseInt(""+_this.product.membersPrice, 10);
        break;
      default:
        price = parseInt(""+_this.product.pd_amt1, 10);
        break;
      }

      let gaData = {
        event: 'productDetail_ARO',
        ecommerce: {
          detail: {
            actionField: { list: _this.ref_title},
            products : [
              {
                name: _this.product.pd_name_kr,
                id: _this.product.pd_id,
                price: price,
                brand: _this.product.brandName ? _this.product.brandName : '',
                category: _this.product.categoryName ? _this.product.categoryName : '',
                variant: 'ARO',
              },
            ]
          }
        }
      };

      _this.$sendAroGA(gaData);
    },

    //GA 전송-장바구니 클릭
    sendGaProductToCart(prod, qty){
      let _this = this;

      let price = parseInt(""+prod.pd_amt1, 10);
      let pd_type = _this.pd_type;
      if(_this.product.uspan_yn == "Y"){
        pd_type = "uspan";
      }
      switch(pd_type){
      case "uspan":
        price = parseInt(""+prod.pd_amt3, 10);
        break;
      case "ntc":
        price = parseInt(""+prod.membersPrice, 10);
        break;
      default:
        price = parseInt(""+prod.pd_amt1, 10);
        break;
      }

      let gaData = {
        event: 'addToCart_ARO',
        ecommerce: {
          add: {
            currencyCode: 'KRW',
            products : [
              {
                name: prod.pd_name_kr,
                id: prod.pd_id,
                price: price,
                brand: prod.brandName ? prod.brandName : '',
                category: prod.categoryName ? prod.categoryName : '',
                variant : 'ARO',
                quantity: qty
              },
            ]
          }
        }
      };

      _this.$sendAroGA(gaData);
    },

    urlClip() {
      let _this = this;
      let linkUrl = document.location.href;

      _this.$aroUrlShareAction(
        linkUrl, //shareLinkUrl
      );
    }

  }
}
</script>
<style>

a.rew19_numbering_up, a.rew19_numbering_down, a.rew19_cart{
  cursor: pointer;
}

#kakaoLinkBtn, #facebookLinkBtn, #kakaoStoryLinkBtn, #urlLinkBtn{
  cursor: pointer;
}

@media only screen and (max-width: 768px){
  .rew19_snsWrap.sns_show {
    display: block;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/product/detail.vue